export default __webpack_public_path__ + "static/media/silver_highlight_blur.a03b0941.png";